import { PAYMENT_METHOD_KEY_NAME } from "../constants/keyNamesSessionStorage";

export const getPaymentMethodName = () => {
  const paymentMethodName = sessionStorage.getItem(PAYMENT_METHOD_KEY_NAME);

  return paymentMethodName;
}
